import React, { useState, useEffect } from "react";
import { FormControl } from 'react-bootstrap';
import { SvgComponent } from "../SvgComponent/SvgComponent";
import SectionRow from "../PantallasEdit/SectionRow/SectionRow";
import { AnimatedIconButton } from "../AnimatedIconButton/AnimatedIconButton";
import EditSection from "../PantallasEdit/EditSection/EditSection";
import { DivisionTerritorialSection } from "../DivisionTerritorialSection/DivisionTerritorialSection";

const valorInicialDireccion = {
    DireccionCalle: "",
    DireccionNumero: "",
    DireccionProvincia: "",
    DireccionProvinciaNombre: "",
    DireccionMunicipio: "",
    DireccionMunicipioNombre: "",
    DireccionBarrio: "",
    DireccionBarrioNombre: "",
    DireccionSubBarrio: "",
    DireccionSubBarrioNombre: "",
    DireccionLinea1: "",
    DireccionLinea2: "",
    Longitud: "",
    Latitud: "",
};

function Direcciones({
                         sectionLabel = "Direcciones",
                         onChange = () => {},
                         initialValue,
                         posicionCanvas
                     }) {
    const [direcciones, setDirecciones] = useState([
        { ...valorInicialDireccion },
    ]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [editingIndex, setEditingIndex] = useState(null);
    const [isButtonAddDisabled, setIsButtonAddDisabled] = useState(false);
    const maxLength = 150;

    useEffect(() => {
        if (initialValue && initialValue.length > 0) {
            setDirecciones(
                initialValue.map((d, index) => ({
                    ...d,
                    Nombre: d.Nombre ?? `Dirección (${index + 1})`,
                }))
            );
        }
    }, [initialValue]);

    const removeDireccion = (index) => {
        setDirecciones((prev) => {
            const nuevasDirecciones = prev.filter((_, i) => i !== index);
            onChange(nuevasDirecciones);
            setActiveIndex(nuevasDirecciones.length - 1);
            return nuevasDirecciones;
        });
    };

    const addDireccion = () => {
        if (!isButtonAddDisabled) {
            setIsButtonAddDisabled(true);
            setDirecciones((prev) => {
                const nuevasDirecciones = [
                    ...prev,
                    {
                        ...valorInicialDireccion,
                        Nombre: `Dirección (${prev.length + 1})`,
                        mapWasOpen: true,
                    },
                ];
                onChange(nuevasDirecciones);
                setEditingIndex(nuevasDirecciones.length - 1);
                setActiveIndex(nuevasDirecciones.length - 1);

                setTimeout(() => {
                    const lastIndex = nuevasDirecciones.length - 1;
                    const inputElement = document.getElementById(
                        `direccion-input-${lastIndex}`
                    );
                    if (inputElement) {
                        inputElement.focus();
                        inputElement.select();
                    }
                }, 0);
                return nuevasDirecciones;
            });
            setTimeout(() => {
                setIsButtonAddDisabled(false);
            }, 1000);
        }
    };

    const handleAccordionToggle = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    const handleDireccionChange = (index, updatedDireccion) => {
        setDirecciones((prevDirecciones) => {
            const nuevasDirecciones = prevDirecciones.map((direccion, i) =>
                i === index
                    ? { ...direccion, ...updatedDireccion, modified: true }
                    : direccion
            );
            onChange(nuevasDirecciones);
            return nuevasDirecciones;
        });
    };

    const handleEditClick = (index) => {
        setEditingIndex(index);
    };

    const handleFinishEditing = () => {
        setEditingIndex(null);
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Enter") {
            handleFinishEditing(index);
        }
    };

    return (
        <EditSection
            title={sectionLabel}
        >
            <SectionRow colspan={2} >
                {direcciones.map((d, index) => {
                    const isOpen = activeIndex === index;
                    const isEditing = editingIndex === index;
                    return (
                    <div key={index} className={`direccion`}>
                                    <DivisionTerritorialSection
                                        mb='2'
                                        posicionCanvas={posicionCanvas}
                                        key={`map_${index}`}
                                        SectionLabel=""
                                        initialValue={d}
                                        hideAddress={true}
                                        showDireccion={true}
                                        showMap={true}
                                        onChange={(value) => {
                                            handleDireccionChange(index, value);
                                        }}
                                    />
                    </div>
                    );
                })}
            </SectionRow>
        </EditSection>
    );
}
export default Direcciones;

